import React from "react";
import style from "./style.module.css";
import Scroller from "../../other-components/HeroScroller/Scroller";

function Modal({ title, description, data, spaceAbove }) {
    return (
        <div className={`${style.parentView} ${spaceAbove ? style.space1X : ''}`}>
            {title ?
                <div className={style.headerView}>
                    <h2>{title}</h2>
                    <p dangerouslySetInnerHTML={{ __html: description }} />
                </div>
                : null
            }

            <div className={[style.contentsView].join(" ")}>
                <Scroller items={data} />
            </div>
        </div>
    );
}

export default Modal;